import React from 'react';
import { Helmet } from 'react-helmet';

export class Termos extends React.Component {
  renderTermosGG = () => {
    return (
      <div className={'p-2 p-lg-5'} style={{ background: '#fff' }}>
        <Helmet>
          <title>Minha Glambox : Termos de Aceite</title>
        </Helmet>

        <p className={'text-center'}>
          <strong>TERMOS E DE USO</strong>
        </p>
        <p> </p>
        <div className={'text-center mb-4'}>
          <h3>Termo de Aceite – Firmado de maneira eletrônica</h3>
          <h5>
            Para fornecimento de serviços de consultoria, conteúdo e promoções por meio de{' '}
            <strong>assinatura</strong>
          </h5>
        </div>
        <div className={'text-md-justify text-sm-left'}>
          <p>
            Este site é operado por <strong>B4A SERVIÇOS DE TECNOLOGIA E COMERCIO S. A</strong>.,
            inscrita no CNPJ sob o nº.: 13.475.001/0001-34 (“<strong>Glambox</strong>”, “
            <strong>Nós</strong>” e “<strong>Nosso</strong>”) (entidade responsável para os efeitos
            da legislação). O endereço físico e demais informações para contato podem ser
            localizadas neste Termo, no item “<i>Atendimento ao Assinante</i>”.
          </p>
          <ol className={'terms-of-service'}>
            <li>
              <h6>Objetivo</h6>
              <p>
                Os termos e condições deste documento (“Termo” ou “Termo de Aceite”) têm por
                objetivo estabelecer as regras para regular o fornecimento de serviços de
                consultoria, conteúdo e promoções, mediante assinatura, ao Contratante de tal
                serviço (<strong>“Você”</strong>, incluídas as variações <strong>“Seu(s)”</strong>)
                e prestados pela <strong>Glambox</strong>, além da forma de prestação dos serviços,
                planos de assinatura, preços, condições de pagamento, Seus direitos e demais
                informações que sejam de Seu interesse e que possam impactar a sua experiência. Por
                favor, leia atentamente este Termo de Aceite, a nossa Política de Privacidade e
                todos os demais documentos, mensagens e informações pertinentes que mencionarmos
                neste documento.
              </p>
              <p>
                A <strong>Glambox</strong> é um serviço personalizado de consultoria, conteúdo,
                promoções e outros serviços, voltados, sobretudo, aos ramos de saúde, beleza,
                cosméticos e estilo de vida, conforme previsto neste Termo. Ao concluir a sua
                Assinatura, Você passará a ter acesso a Sua área de Assinante (Universo Glam), no
                qual passará a ter acesso a conteúdos exclusivos, comunidade dos assinantes, acesso
                a benefícios disponibilizados e/ou concedidos pela <strong>Glambox</strong>, vídeos
                exclusivos, Glampoints para troca por produtos, concursos, sorteios, conteúdos
                instrutivos e educativos, sessão Glammag, vídeos disponibilizados na GlamTV,
                descontos em compras no Glamshop, possibilidade do recebimento de kits com produtos
                enviados por marcas renomadas, entre outros diversos benefícios que existam e/ou
                venham a existir.
              </p>
              <p>
                Nada neste Termo tem a intenção de afetar Seus direitos garantidos por lei. Se
                houver alguma dúvida quanto a prevalência entre tais direitos e este Termo, Seus
                direitos garantidos pela lei prevalecerão. Ao contratar os Serviços e realizar a
                adesão a este Termo de Aceite, Você está concordando integralmente com este Termo e
                com as condições nele estabelecidas, por isso é importante que Você o leia com muita
                atenção.
              </p>
            </li>
            <li className="mt-3">
              <h6>Sumário deste Termo</h6>
              <p>Este Termo é dividido nos seguintes tópicos:</p>
              <p> </p>
              <p>
                <i>
                  <strong>1.</strong>
                </i>{' '}
                <i>
                  <strong>Objetivo</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>2.</strong>
                </i>{' '}
                <i>
                  <strong>Sumário deste Termo</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>3.</strong>
                </i>{' '}
                <i>
                  <strong>Definições</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>4.</strong>
                </i>{' '}
                <i>
                  <strong>Dos Serviços prestados pela Glambox</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>5.</strong>
                </i>{' '}
                <i>
                  <strong>Adesão</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>6.</strong>
                </i>{' '}
                <i>
                  <strong>Ofertas promocionais</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>7.</strong>
                </i>{' '}
                <i>
                  <strong>Política de Privacidade</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>8.</strong>
                </i>{' '}
                <i>
                  <strong>Dos Sorteios e concursos</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>9.</strong>
                </i>{' '}
                <i>
                  <strong>Das Permissões para uso de imagem</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>10.</strong>
                </i>{' '}
                <i>
                  <strong>Do frete</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>11.</strong>
                </i>{' '}
                <i>
                  <strong>Forma e Condições de Pagamento</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>12.</strong>
                </i>{' '}
                <i>
                  <strong>Vigência, Renovação e Extinção / Política de Cancelamento</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>13.</strong>
                </i>{' '}
                <i>
                  <strong>Capacidade para Aceitar os Termos e Condições</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>14.</strong>
                </i>{' '}
                <i>
                  <strong>Obrigações e responsabilidades da Glambox</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>15.</strong>
                </i>{' '}
                <i>
                  <strong>Das Suas obrigações</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>16.</strong>
                </i>{' '}
                <i>
                  <strong>Atendimento ao Assinante</strong>
                </i>
              </p>
              <p>
                <i>
                  <strong>17.</strong>
                </i>{' '}
                <i>
                  <strong>Disposições Finais</strong>
                </i>
              </p>

              <p> </p>
              <p>
                Em razão da multiplicidade de Temas, recomendamos que leia atentamente a todos os
                tópicos deste Termo, e, em caso de dúvidas, entre em contato com a{' '}
                <strong>Glambox</strong> por intermédio de um dos canais de atendimento
                disponibilizados.
              </p>
            </li>
            <li className="mt-3">
              <h6>Definições</h6>
              <p>
                Além das definições anteriormente citadas, sempre que em letras maiúsculas, os
                termos abaixo indicados terão o significado que a seguir lhes é apontado, seja no
                plural ou no singular:
              </p>
              <p> </p>
              <p>
                <strong>(i)</strong> Assinatura: contraprestação mensal, conforme plano de
                Assinatura escolhido, que você paga pela fruição dos Serviços oferecidos pela
                <strong> Glambox</strong>;
              </p>
              <p>
                <strong>(ii)</strong> Cupons de Desconto: cupons emitidos pelos Fornecedores, pela
                própria
                <strong> Glambox</strong> ou por parceiros dela, destinados à aquisição da
                Assinatura sob condições promocionais, segundo os termos e condições especificados
                pelos Fornecedores, Parceiros e/ou nos respectivos cupons;
              </p>
              <p>
                <i>*A </i>
                <i>
                  <strong>Glambox</strong>
                </i>
                <i>
                  {' '}
                  não se responsabiliza pelos produtos e serviços fornecidos pelos Fornecedores ou
                  Parceiros, nos quais foram concedidos os Cupons de Descontos.
                </i>
              </p>
              <p>
                <strong>(iii)</strong> Fornecedores: conceituadas empresas do ramo de cosméticos,
                beleza, saúde ou estilo de vida, responsáveis pela fabricação e/ou importação dos
                Brindes ou prestação de serviços congêneres;
              </p>
              <p>
                <strong>(iv)</strong> Parceiros: conceituadas empresas do ramo de cosméticos,
                beleza, saúde ou estilo de vida, responsáveis pela prestação de serviços ou
                fornecimentos de produtos que possam ser de Seu interesse, que firmaram parcerias
                com a <strong>Glambox</strong> para o fornecimento de condições especiais ou
                promocionais para a realização da Assinatura;
              </p>
              <p>
                <strong>(v)</strong> Glammag: é o portal disponibilizado pela{' '}
                <strong>Glambox</strong> e destinado à publicação de notícias, informativos,
                matérias e materiais de Seu interesse, em formato digital que podem ou não serem
                replicados em formato impresso e enviados com seu Kit;
              </p>
              <p>
                <strong>(vi)</strong> Universo Glam: É o conjunto de benefícios e acessos exclusivos
                obtidos e vinculados a efetivação da Sua Assinatura;
              </p>
              <p>
                <strong>(vii)</strong> Kit: conjunto de Materiais Promocionais, Brindes, Amostras
                e/ou Cupons de Descontos, todos fornecidos pelos Fornecedores, selecionados a
                critério exclusivo da <strong>Glambox</strong> e encaminhados de forma gratuita e
                mensalmente em uma caixa para você, em razão da Assinatura, enquanto esta estiver
                vigente;
              </p>
              <p>
                <strong>(viii)</strong> Brindes: produtos cosméticos, de beleza, de saúde ou de
                estilo de vida, fornecidos pelos Fornecedores, selecionados a critério exclusivo da{' '}
                <strong>Glambox</strong> e encaminhados para você, dentro dos Kits, tais como, p.
                ex.: cremes, loções, perfumes, maquiagens, esmaltes, shampoos, acessórios diversos,
                entre outros, podendo se tratar de amostras grátis, miniaturas, sachês ou embalagens
                de tamanho comercial, entre outras apresentações;
              </p>
              <p>
                <strong>(ix)</strong> Materiais Promocionais: catálogos, folders, mostruários ou
                qualquer outro material promocional disponibilizado pelos Fornecedores, e incluídos
                nos Kits, destinados à divulgação de seus produtos ou serviços;
              </p>
              <p>
                <strong>(x)</strong> Amostra: Amostras grátis, são amostras ou porções de um produto
                que são fornecidas para você por um Fornecedor e enviadas em Seu Kit, para que você
                possa experimentar, testar e avaliar um produto;
              </p>
              <p>
                <strong>(xi)</strong> Serviços: serviços periódicos de conteúdo, consultoria e
                promoções relacionadas ao ramo de cosméticos, beleza, saúde e estilo de vida e
                oferecidos pela
                <strong>Glambox</strong> aos Assinantes, por meio de seu Website, bem como o serviço
                de entrega de Kits gratuitos em razão da Assinatura;
              </p>
              <p>
                <strong>(xii) </strong>Website: sítio na internet da <strong>Glambox</strong>,
                situado no endereço www.glambox.com.br, controlado pela sede da{' '}
                <strong>Glambox</strong> localizada no Brasil. Por esta razão, a{' '}
                <strong>Glambox</strong> não garante que o Website esteja disponível para acesso em
                outros países. Se você acessar o Website e contratar os Serviços em outras
                jurisdições, o faz por conta própria e é responsável pelo fiel cumprimento da
                legislação local, isentando a <strong>Glambox</strong> de qualquer responsabilidade;
              </p>
              <p>
                <strong>(xiii)</strong> Glampoints: pontos creditados para você, por liberalidade da
                <strong>Glambox</strong>, que poderão ser convertidos em créditos para aquisição de
                produtos e serviços promocionais fornecidos pelos Fornecedores, segundo as regras
                contidas na Definição dos Glampoints disponíveis no Website. Para a
                utilização/resgate dos Glampoints, a Assinatura deverá estar vigente na data do
                resgate; e,
              </p>
              <p>
                <strong>(xiv)</strong> Glamshop: Trata-se de um e-commerce voltado à aquisição de
                produtos e serviços (<a href="https://glamshop.com.br">https://glamshop.com.br</a>),
                parceiro da
                <strong>Glambox</strong>, onde os Glampoints poderão ser utilizados e os Assinantes
                da <strong>Glambox</strong> detém descontos e condições especiais para aquisição de
                produtos e serviços.
              </p>
            </li>
            <li className="mt-3">
              <h6>Dos Serviços prestados pela Glambox</h6>
              <p>
                A <strong>Glambox</strong> é um serviço personalizado de consultoria, conteúdo,
                promoções e outros serviços, voltados, sobretudo, aos ramos de saúde, beleza,
                cosméticos e estilo de vida, conforme previsto neste Termo. Ao concluir a sua
                Assinatura, Você passará a ter acesso a Sua área de Assinante (Universo Glam), no
                qual passará a ter acesso a conteúdos exclusivos, comunidade dos assinantes, acesso
                a benefícios disponibilizados e/ou concedidos pela <strong>Glambox</strong>, vídeos
                exclusivos, Glampoints para troca por produtos, concursos, sorteios, conteúdos
                instrutivos e educativos, sessão Glammag, vídeos disponibilizados na GlamTV,
                descontos em compras no Glamshop, possibilidade do recebimento de kits com produtos
                enviados por marcas renomadas, entre outros diversos benefícios que existam e/ou
                venham a existir. Integram os Serviços oferecidos a Você, pela{' '}
                <strong>Glambox</strong>, entre outros, o fornecimento e a intermediação de de
                conteúdos exclusivos dos ramos de cosméticos, beleza, saúde e estilo de vida no
                Website, mídias sociais, Blogs, Portais de Comunicação e eventos, tais como:
                divulgação de notícias; novidades; ofertas; lançamentos; comparativos; dicas e
                reviews, bem como a oportunidade de Você avaliar os Brindes, Amostras, produtos e
                itens recebidos gratuitamente no endereço que indicar, em razão da Assinatura,
                reunidos na forma de Kits mensais, cuja avaliação poderá ser recompensada com
                Glampoints da seguinte forma:
              </p>
              <p> </p>
              <p>
                <strong>(i)</strong> Os Kits conterão Brindes aleatórios, escolhidos a critério
                exclusivo da <strong>Glambox</strong>, e serão enviados mensalmente, conforme o
                plano de Assinatura escolhido, ao endereço indicado por Você, no momento de Seu
                cadastro e após concluída a sua adesão;
              </p>
              <p>
                <strong>(ii)</strong> O primeiro Kit será despachado até o final do mês seguinte ao
                da data em que realizada a Assinatura e concluída a Adesão, podendo levar, na
                primeira entrega, até 60 (sessenta) dias para ser entregue para Você, contados da
                data em que concluída a Adesão e confirmado o pagamento;
              </p>
              <p>
                <strong>(iii)</strong> Após a primeira entrega, o Kit será despachado até o final do
                mês seguinte ao de lançamento do Kit (p. ex.: o Kit referente ao mês de outubro,
                poderá ser despachado até o final do mês de novembro). E a entrega deverá ocorrer
                até o dia 15 do mês seguinte ao que ocorrer o despacho. Entretanto, em que pese os
                prazos aqui estipulados e com os quais Você declara concordância, a{' '}
                <strong>Glambox</strong> envidará os melhores esforços a fim de que a entrega se dê
                com a maior brevidade possível;
              </p>
              <p>
                <strong>(iv)</strong> A entrega dos Kits ocorrerá no endereço informado por Você em
                Seu cadastro no Website e apenas mediante assinatura do comprovante de recebimento
                por Você mesmo ou por qualquer outra pessoa presente no local, que indique ser
                responsável pelo recebimento ou ter qualquer relação de parentesco ou amizade com
                Você. Caso não haja pessoa presente, nestes termos, para o recebimento e assinatura
                do comprovante, o Kit não será entregue, e uma nova tentativa de entrega será feita
                em até 48 (quarenta e oito) horas úteis após a constatação de que não houve êxito na
                tentativa de entrega (Você poderá acompanhar as informações e atualizações de
                entrega do Kit através de sua página em nosso Website efetuando Seu login). Não
                sendo possível a entrega após a segunda tentativa, o Kit será devolvido à{' '}
                <strong>Glambox</strong>. Neste caso, Você poderá requerer, em até 20 (vinte) dias,
                após a última tentativa de entrega do Kit por parte de <strong>Glambox</strong>, a
                entrega do referido Kit, mediante o recolhimento do Kit nos Correios e pagamento do
                Sedex a cobrar (Você arcará com os custos de postagem, neste caso). O Kit será
                despachado em até 30 (trinta) dias corridos contados da data do recebimento pela{' '}
                <strong>Glambox</strong> da sua comunicação, informando o Seu desejo de receber o
                Kit. Caso Você não manifeste o desejo de receber o Kit em até 20 (vinte) dias,
                contados do envio da comunicação da impossibilidade da entrega pela{' '}
                <strong>Glambox</strong>, esta poderá dar ao respectivo Kit outro destino, a seu
                exclusivo critério. Neste caso, não haverá dever de envio de um novo Kit referente a
                mesma edição, sendo possibilitado o reembolso e estorno dos valores referentes a
                edição cuja entrega não se efetivou.
              </p>
              <p>
                <strong>(v)</strong> Salvo em caso de avarias nos itens, identificados no momento da
                entrega, não será aceita a devolução de Kits ou de qualquer dos Brindes, Amostras,
                Produtos, Itens ou quaisquer materiais neles contidos, após a confirmação de entrega
                no Seu endereço, em qualquer hipótese;
              </p>
              <p>
                <strong>(vi)</strong> O recebimento do Kit por Você, Seu parente ou pessoa por Você
                autorizada, somente deverá ser feito se a caixa estiver intacta, não serão
                realizados pela
                <strong>Glambox</strong> quaisquer reembolsos, trocas, devoluções ou estornos
                referentes a qualquer item que componha o Kit, razão pela qual sua conferência deve
                ser realizado no ato da entrega, e, caso verifique alguma inconsistência, o
                recebimento deve ser recusado;
              </p>
              <p>
                <strong>(vii)</strong> A <strong>Glambox</strong> poderá enviar para Você
                questionários que poderão ser preenchidos, sobre sua opinião quanto aos Brindes,
                Amostras, Produtos, Materiais Promocionais ou demais itens recebidos em Seu Kit. Em
                contrapartida pelo preenchimento do questionário, Você receberá Glampoints, conforme
                a Definição dos Glampoints disponível no Website ou especificados pela{' '}
                <strong>Glambox</strong> e informados para Você;
              </p>
              <p>
                <strong>(viii)</strong> Você, desde já, autoriza a <strong>Glambox</strong> a
                divulgar as informações coletadas por meio de tais questionários aos seus parceiros
                comerciais. Neste caso, a <strong>Glambox</strong> envidará os melhores esforços
                para manter as informações anonimizadas, porém, não poderá garantir que nenhum dado
                que possa identificá-lo ou torná-lo identificável, não será transferido, o que,
                desde já, Você informa deter ciência e autoriza à <strong>Glambox</strong>
                fazê-lo. Para maiores informações, favor consultar o documento “Política de
                Privacidade”, acessível por meio do link:{' '}
                <a href="https://www.glambox.com.br/politica-de-privacidade/;">
                  https://www.glambox.com.br/politica-de-privacidade/;
                </a>
              </p>
              <p>
                <strong>(ix)</strong> Caso o Kit não tenha sido entregue, a entrega tenha sido
                recusada em razão de avarias ou vícios ou o Kit tenha se extraviado, é assegurado a
                Você o direito de requerer, por meio dos canais de comunicação disponibilizados, a
                entrega de novo Kit. Antes da postagem deste novo Kit, e, sendo o caso, a{' '}
                <strong>Glambox</strong> poderá analisar a existência de justo motivo para a recusa
                na entrega, e verificar se procederá ao envio de um novo Kit ou do mesmo Kit já
                enviado, caso não verifique motivos relevantes para a recusa no recebimento. Sendo
                decidido pela <strong>Glambox</strong> pelo envio de um novo Kit, este novo Kit será
                despachado em até 15 (quinze) dias contados da data de confirmação, pela{' '}
                <strong>Glambox</strong>, da não entrega do Kit, e será entregue em até 30 (trinta)
                dias a contar da data da nova postagem. Nesse caso, Você poderá ainda, em
                substituição a entrega deste Kit, solicitar o estorno do valor cobrado pelo Kit, ao
                invés de um novo envio, que será efetuado em Seu cartão de crédito utilizado como
                meio de pagamento, e será enviado para o meio de processamento de pagamento em até
                15 (quinze) dias contados da data da sua manifestação solicitando o estorno. Porém,
                a efetivação do estorno em sua fatura depende de fatores externos a
                <strong>Glambox</strong>, como data de fechamento de sua fatura, regras instituídas
                pela bandeira do Seu cartão, e critérios do emissor. Na hipótese de Você não ter
                realizado o pagamento via Cartão de Crédito, a <strong>Glambox</strong> poderá
                realizar o reembolso dos valores em conta, o qual será realizado no prazo de até 30
                (trinta) dias, da data em que acatado o pedido de reembolso.
              </p>
            </li>
            <li className="mt-3">
              <h6>Adesão</h6>
              <p>
                A<strong> Glambox </strong>presta serviço personalizado de consultoria, conteúdo,
                promoções e outros serviços, voltados, sobretudo, aos ramos de saúde, beleza,
                cosméticos e estilo de vida. Referida prestação se dá por intermédio de vários
                Planos de Assinatura que poderão ser contratados por Você, a Seu critério: (i) Plano
                Mensal; (ii) Plano Semestral; e, (iii) Plano Anual, conforme detalhados neste Termo
                ou outros que existam e/ou venham a existir. Ao contratar os Serviços, Você confirma
                que concorda com: (i) a Política de Privacidade da<strong> Glambox </strong>e
                autoriza que Seus dados sejam utilizados de acordo com tal política; (ii) este
                Termo; (iv) Contrato do Plano de Assinatura aplicável, de acordo com o plano
                escolhido por Você.
              </p>
              <p>
                Ao contratar os Serviços, Você confirma que concorda com: (i) a Política de
                Privacidade da
                <strong> Glambox </strong>e autoriza que Seus dados sejam utilizados de acordo com
                tal política; (ii) este Termo; (iv) Contrato do Plano de Assinatura aplicável, de
                acordo com o plano escolhido por Você.
              </p>
              <p>
                Para ter acesso a quaisquer dos Serviços, independentemente do Plano de Assinatura,
                Você precisará ter criado e manter ativa uma Conta <strong>Glambox</strong>, nos
                termos da Política de Privacidade da<strong> Glambox</strong>, por esta razão é
                necessário, ao acessar o Website, que Você clique em: (i){' '}
                <u>
                  <a href="https://assine.glambox.com.br/1" rel="nofollow" target="_blank">
                    https://assine.glambox.com.br/1
                  </a>
                </u>
                , para assinatura mensal; (ii){' '}
                <u>
                  <a href="https://assine.glambox.com.br/3" rel="nofollow" target="_blank">
                    https://assine.glambox.com.br/3
                  </a>
                </u>
                , para assinatura semestral; ou, (iii){' '}
                <u>
                  <a href="https://assine.glambox.com.br/2" rel="nofollow" target="_blank">
                    https://assine.glambox.com.br/2
                  </a>
                </u>
                , para assinatura anual; e escolher o Plano pelo qual deseja Assinar os serviços
                prestados pela <strong>Glambox</strong>.
              </p>
              <p>
                Após isso, você deverá concluir o Seu cadastro, informar os dados para cobrança,
                aceitar os termos e condições aqui previstos e manifestar sua concordância com a
                Política de Privacidade da <strong>Glambox</strong>, incorporada ao presente Termo
                de Aceite e também localizada no seguinte website:
                <u>
                  <a
                    href="https://www.glambox.com.br/politica-de-privacidade/"
                    rel="nofollow"
                    target="_blank"
                  >
                    https://www.glambox.com.br/politica-de-privacidade/
                  </a>
                </u>
                .
              </p>
              <p>
                <strong>Concluídos os passos acima indicados, </strong>
                <strong>
                  <u>e confirmado o pagamento</u>
                </strong>
                <strong>
                  , este Termo de Aceite considerar-se-á celebrado e obrigatório entre as Partes,
                  sendo certo que, assim procedendo, Você declara ter lido e compreendido todos os
                  termos e condições deste documento, razão pela qual é recomendável que Você
                  imprima uma cópia deste Termo de Aceite para futura referência.
                </strong>
                .
              </p>
              <p>
                A <strong>Glambox</strong>, a seu exclusivo critério e a qualquer tempo, poderá
                revisar e alterar este Termo de Aceite, documentos correlatos, regras e condições
                informadas a Você no ato da sua Assinatura e demais documentos mencionados neste
                Termo. A<strong> Glambox</strong>, sempre que possível, mas não obrigatoriamente,
                desde que dentro da legislação aplicável, informará para você sobre mudanças neste
                Termo e nas condições aqui previstas e em sua Política de Privacidade. Como esta
                informação é discricionária, Você deverá consultar e reler tais documentos
                periodicamente e cumprir tais revisões ou alterações. As versões mais atualizadas
                estarão disponíveis nos Websites mencionados acima e, ao acessar o Website com Seu
                usuário e senha, poderá ser requerido que Você aceite novamente e eletronicamente os
                novos termos e condições. As alterações a este Termo de Aceite que importem em ônus
                financeiro serão feitas mediante comunicação prévia, com pelo menos 30 dias de
                antecedência da data em que as alterações se apliquem a Você.
              </p>
            </li>
            <li className="mt-3">
              <h6>Das ofertas promocionais</h6>
              <p>
                A<strong> Glambox </strong>poderá disponibilizar ofertas, planos, códigos e/ou
                cupom(ns) de desconto ou assinaturas promocionais especiais (“Ofertas”). A
                elegibilidade para as Ofertas é determinada pela <strong> Glambox</strong> a seu
                exclusivo critério. A<strong> Glambox </strong>se reserva ao direito de revogar uma
                Oferta e suspender sua conta se determinarmos que Você não é elegível. A
                <strong> Glambox </strong>poderá usar informações como identificação, forma de
                pagamento, tempo de assinatura, interações com a<strong> Glambox</strong>, local de
                residência ou para entrega dos Kits e perfil de beleza para determinar a
                elegibilidade para a Oferta. Os requisitos de elegibilidade, bem como outras
                limitações e condições, serão revelados quando Você se inscrever para a Oferta ou em
                outras comunicações que disponibilizarmos para Você ou, ainda, quando Você nos
                solicitar.
              </p>
              <p>
                Para todos os efeitos, as Ofertas não serão consideradas e/ou confundidas com os
                descontos concedidos em razão da vigência do Plano de Assinatura, conforme descrito
                no item 12 abaixo, podendo ou não serem acrescidas aos descontos, nos termos
                estabelecidos pela
                <strong> Glambox</strong>.
              </p>
            </li>
            <li className="mt-3">
              <h6>Política de Privacidade</h6>
              <p>
                A <strong> Glambox</strong>. possui política expressa sobre como realiza a coleta e
                o tratamento dos dados pessoais obtidos de Você por meio do Website, sua Assinatura
                e demais meios de contato com a <strong> Glambox</strong>. As informações de
                cadastro e demais informações estão sujeitas ao tratamento definido na referida
                Política.
              </p>
              <p>
                Para maiores informações, favor consultar o documento “Política de Privacidade”,
                acessível por meio do link:{' '}
                <a href="https://www.glambox.com.br/politica-de-privacidade/">
                  https://www.glambox.com.br/politica-de-privacidade/
                </a>
                . Tal documento constitui parte integrante e indissociável do presente Termo e
                deverá ser lido atentamente por você.
              </p>
              <p>
                Na hipótese das disposições contidas nos Termos e Condições que conflitarem com as
                disposições previstas na Política de Privacidade, observar-se-á o disposto no
                documento que trate do tema com maior especificidade.
              </p>
            </li>
            <li className="mt-3">
              <h6>Dos Sorteios e concursos</h6>
              <p>
                A<strong> Glambox </strong>poderá, mas não necessariamente fará, concursos, sorteios
                e/ou promoções condicionadas a termo, condição e/ou encargo, conforme definido em
                ato próprio e previamente informado, além de eventuais outras limitações que sejam
                informadas para Você e os participantes no momento do cadastro no concurso, sorteio
                e/ou promoção.
              </p>
              <p>
                Salvo se determinado de forma diversa, os concursos, sorteios e/ou promoções serão
                destinadas aos Assinantes, e o cadastro será livre e gratuito (inclusive por
                intermédio de redes sociais e limitados aos Termos e Condições e Políticas Próprias
                das referidas Redes, sobre as quais a<strong> Glambox </strong>não detém qualquer
                responsabilidade), desde que Você forneça os dados necessários e cumpra com a
                integridade e regras específicas, ficando, salvo se de outro modo estipulado nas
                regras próprias, vedado o uso de mecanismos automatizados com o fito de obter
                vantagem indevida em detrimento dos demais participantes pessoas físicas. Esta norma
                tem o objetivo de garantir um ambiente de concorrência leal para todos os
                participantes.
              </p>
              <p>
                Salvo se estipulado de forma diversa, os concursos, sorteios e promoções estarão
                disponíveis somente para residentes legais, domiciliados e estabelecidos no Brasil,
                com idade igual ou superior a 18 (dezoito) anos ou legalmente permitidos e/ou
                responsáveis.
              </p>
              <p>
                Os concursos, sorteios e promoções estarão disponíveis apenas durante um período
                determinado, e, se o caso, terão quantidades previamente estabelecidas e limitadas.
              </p>
              <p>
                Os abusos e/ou violações de políticas resultarão no cancelamento ou na
                desqualificação em concursos, sorteios e promoções em andamento e/ou futuros.
                Reservando-se a<strong> Glambox </strong>o direito de cancelar participações
                vencedoras caso constatado qualquer abuso e/ou violação.
              </p>
              <p>
                Salvo se estipulado e informado de forma diversa, somente será permitida uma
                participação por pessoa, e as participações não poderão ser transferidas.
              </p>
              <p>
                A<strong> Glambox</strong>, a seu exclusivo critério, poderá alterar, a qualquer
                momento, as regras e processos dos concursos, sorteios e/ou promoções.
              </p>
              <p>
                Caso os concursos, sorteios e/ou promoções sejam condicionados à efetivação de uma
                Assinatura de terceiro, fica desde já condicionada a participação a adesão do
                terceiro a este Termo. A<strong> Glambox </strong>se reserva ao direito, a seu
                exclusivo critério, de desqualificar qualquer indivíduo que descubra estar
                interferindo ilegalmente no processo de participação ou com o funcionamento da
                participação, ou a violar o presente Termo ou as eventuais regras específicas que
                vierem a existir, ou a agir de forma perturbadora ou antidesportiva. Qualquer
                tentativa de qualquer pessoa de prejudicar o funcionamento legítimo dos concursos,
                sorteios e/ou promoções pode constituir uma violação da legislação civil e criminal
                e, caso se verifique, a<strong> Glambox </strong>reserva o direito de requerer uma
                indenização da pessoa em questão, até o limite máximo permitido por lei ou
                estipulado por uma autoridade competente. A não aplicação, por parte da
                <strong> Glambox</strong>, de qualquer direito, normas ou regras deste Termo ou das
                regras especificas eventualmente existentes não constitui e nem deve ser
                interpretado como uma renúncia do direito em questão.
              </p>
              <p>
                Caso a<strong> Glambox </strong>seja impedida de continuar com o concurso, sorteio
                e/ou promoção ou a integridade e/ou viabilidade do concurso, sorteio e/ou promoção
                seja gravemente comprometida por um acontecimento fora do controle da
                <strong> Glambox</strong>, incluindo, sem caráter limitativo, incêndio, inundação,
                epidemia, pandemia, terremoto, explosão, conflito laboral ou greve, motivos de força
                maior e caso fortuito, avaria de equipamento, revolta ou perturbação da ordem
                pública, guerra (declarada ou não), ameaça ou atividade terrorista, ou qualquer lei
                do governo, ordem ou regulamento, ordem de qualquer tribunal ou jurisdição, infeção
                por vírus informático, intervenção não autorizada, falhas técnicas ou outras causas
                que, no limite do razoável, não estejam sob o controle da
                <strong> Glambox </strong>(todos eles eventos ou ocorrências de força maior), a
                <strong> Glambox </strong>tem o direito de, a seu critério exclusivo, abreviar,
                modificar, suspender, cancelar ou terminar o concurso, sorteio e/ou promoção sem
                qualquer outra obrigação.
              </p>
              <p>
                Ao participarem do concurso, sorteio e/ou promoção, Você e os demais participantes
                concordam, até ao limite máximo permitido pela legislação aplicável, que a
                <strong> Glambox</strong>, as empresas afiliadas e demais empresas que possam, de
                qualquer modo, estarem vinculadas ao concurso, sorteio e/ou promoção, bem como os
                respetivos responsáveis, diretores, funcionários e agentes (as "Partes Isentas") não
                serão responsáveis por quaisquer danos ou custos decorrentes da participação no
                concurso, sorteio e/ou promoção ou realização da Assinatura, concordância com este
                Termo ou a aquisição de produtos, incluindo, sem caráter limitativo: (a) intervenção
                humana não autorizada no concurso, sorteio e/ou promoção; (b) erros técnicos
                relacionados com computadores, servidores, fornecedores ou linhas de rede
                telefónica; (c) erros de impressão; (d) correio perdido, atrasado, sem franquia, mal
                endereçado ou impossível de entregar; (e) erros na administração do no concurso,
                sorteio e/ou promoção ou no processamento das participações; ou, (f) ferimentos ou
                danos causados às pessoas ou propriedade que possam ser causados, direta ou
                indiretamente, na totalidade ou em parte, devido à participação no concurso, sorteio
                e/ou promoção ou à aquisição de produto. Até ao limite máximo permitido pela
                legislação aplicável, Você e os demais participantes renunciam ao direito de
                reclamar quaisquer prejuízos, incluindo, sem caráter limitativo, danos punitivos,
                consequentes, diretos ou indiretos. Você e os participantes concordam que as Partes
                Isentas não fizeram qualquer representação ou garantia, expressa ou implícita, de
                fato ou de direito, relativamente a qualquer garantia de receber eventual prêmio.
              </p>
              <p>
                Caso Você ou os demais participantes decidam participar do concurso, sorteio e/ou
                promoção, desde já, autorizam o uso interno e externo de seus dados, informações e
                imagens, inclusive, podendo divulgá-las interna e externamente, para fins de
                garantir acesso às pessoas interessadas quanto a lisura e existência de Sua
                participação. A presente autorização é concedida a título gratuito, abrangendo o uso
                da imagem acima mencionada em todo território nacional e no exterior, em todas as
                modalidades utilizadas para a divulgação do concurso, sorteio e/ou promoção, bem
                como para a divulgação de resultados, inclusive, mas sem se limitar, aos Sites da
                <strong> Glambox </strong>e as redes sociais da<strong> Glambox</strong>, parceiros,
                clientes e todas as outras pessoas que sejam, de qualquer forma interessadas na
                realização e/ou resultado do concurso, sorteio e/ou promoção.
              </p>
            </li>
            <li className="mt-3">
              <h6>Das permissões para o uso de imagem</h6>
              <p>
                Respeitados os Seus direitos e a Política de Privacidade, caso Você interaja com
                Nossas redes sociais, Nossos Sites, Participe de Nossos eventos, der o seu feedback
                a respeito da Assinatura, dos Serviços e/ou dos produtos, participe dos programas de
                influenciadores, tais como, mas não se limitando a: Glampartner, Glamgirl,
                Glamqueen, entre outros, poderemos, na medida do possível e sempre com a finalidade
                específica de divulgação dos Serviços, inclusive no Site e redes sociais, utilizar a
                Sua imagem e/ou dados contidos na sua rede social, ficando, desde já, o uso interno
                e externo de seus dados, informações e imagens autorizado, inclusive. A presente
                autorização é
                <strong>
                  <u>concedida a título gratuito</u>
                </strong>
                , sem qualquer direito a indenização, abrangendo o uso da imagem acima mencionada em
                todo território nacional e no exterior, em todas as modalidades utilizadas para a
                divulgação dos serviços e pelo prazo da Sua Assinatura e/ou enquanto for de
                interesse da
                <strong> Glambox</strong>.
              </p>
            </li>
            <li className="mt-3">
              <h6>Do frete</h6>
              <p>
                Caso o local de entrega escolhido por Você esteja ou venha a estar localizado fora
                do território atendido pelo serviço de entrega da{' '}
                <strong>
                  Glambox <u>de forma gratuita</u>
                </strong>
                , os eventuais custos adicionais para realização da entrega poderão ser repassados
                para Você no momento da Adesão.
              </p>
              <p>
                Caso; (i) Você solicite a alteração do endereço; (ii) o endereço deixe de ser
                atendido de forma gratuita por ato unilateral da<strong> Glambox</strong>; ou, (iii)
                o valor do frete sofra um aumento, enquanto sua Assinatura estiver vigente; as
                alterações de preço do frete serão aplicadas somente 30 (trinta) dias após o envio
                da notificação a Você. Na hipótese de Você não concordar com essa cobrança adicional
                de frete, Você poderá cancelar a Assinatura, sem qualquer ônus, em até 07 (sete)
                dias do recebimento das informações sobre os custos adicionais. Esta regra aplica-se
                apenas para a primeira entrega, uma vez que esse valor adicional já será de Seu
                conhecimento nas demais.
              </p>
              <p>
                Você declara e garante que caso concorde com a cobrança do adicional do frete,
                dispõe de recursos suficientes para realizar o pagamento de forma antecipada ao
                envio do Kit, não havendo qualquer obrigação por parte da<strong> Glambox </strong>
                de enviar o Kits caso não haja o pagamento do frete.
              </p>
            </li>
            <li className="mt-3">
              <h6>Forma e Condições de Pagamento</h6>
              <p>
                O preço da Assinatura e condições de pagamento pelos Serviços é àquele aceito por
                Você, e informado pela<strong> Glambox</strong>, no momento da Adesão, que faz parte
                integrante deste Termo de Aceite.
              </p>
              <p>
                A<strong> Glambox </strong>oferece vários planos de Assinatura, sendo que cada plano
                de Assinatura terá valores, condições de pagamento, cobrança, renovação e
                especificidades próprias, conforme informado neste Termo e cujas condições serão
                previamente informadas a Você no momento da Assinatura e da Adesão.
              </p>
              <p>
                Independentemente do plano de Assinatura escolhido, os pagamentos da Assinatura,
                durante a vigência da Assinatura e deste Termo de Aceite, serão cobrados de uma
                única vez e parcelados de mensalmente por Você, sendo o primeiro pagamento devido na
                data da Adesão e os demais nos meses subsequentes, conforme métodos de pagamento
                aceitos pela
                <strong> Glambox</strong>.
              </p>
              <p>
                <strong>
                  Ressalte-se que mesmo que os pagamentos sejam feitos de forma parcelada, isso não
                  será interpretado como uma Assinatura mensal, sendo o prazo de pagamento vinculado
                  ao plano de Assinatura escolhido por Você.
                </strong>
              </p>
              <p>
                Os pagamentos da Assinatura, durante a vigência dessa e do Termo de Aceite, serão
                realizados mensalmente, porém, nos planos celebrados pelo prazo de 06 (seis) meses
                ou 12 (doze) meses, a<strong> Glambox</strong>, no momento da Adesão ou renovação de
                sua Assinatura, realizará uma tentativa de cobrança em Seu cartão de crédito no
                valor integral do valor da assinatura, de forma parcelada, e, caso não obtenha
                êxito, poderá realizar a cobrança mês a mês, sendo, neste caso, o primeiro pagamento
                devido na data da adesão e os demais nos meses subsequentes, cuja cobrança será
                realizada até o dia 05 (cinco) de cada mês; caso a<strong> Glambox </strong>não
                obtenha êxito na cobrança realizada até o dia 05 (cinco), a
                <strong> Glambox </strong>fará mais 03 (três) novas tentativas de cobrança de 05
                (cinco) em 05 (cinco), sempre por meio de cartão de crédito. Caso a
                <strong> Glambox </strong>não obtenha êxito em realizar a cobrança da mensalidade em
                Seu cartão de crédito em nenhuma destas tentativas, Você continua responsável por
                todos os valores não pagos. Se um pagamento não for liquidado com sucesso, devido à
                perda de validade, insuficiência de fundos ou qualquer outro motivo, poderemos
                cancelar o Seu acesso ao serviço até que consigamos fazer a cobrança de uma Forma de
                Pagamento válida. Para tanto, a<strong> Glambox</strong>, após a realização de
                tentativas de cobrança em cartão de crédito, enviar-lhe-á uma cobrança via boleto
                bancário, o qual será enviado para os Seus contatos eletrônicos constantes no Seu
                cadastro e informado por você no momento da Adesão e vinculados a sua Assinatura
                (inclusive e-mail; SMS, entre outros que a<strong> Glambox </strong>
                entender serem necessários), para pagamento em até 03 (três) dias úteis. A
                <strong>
                  {' '}
                  Glambox <u>não</u> enviará o boleto em formato físico para o Seu endereço.{' '}
                </strong>
                Na eventualidade de não haver o pagamento do boleto bancário dentro do prazo
                estabelecido, a sua Assinatura será cancelada, e, caso o plano ainda esteja vigente,
                havendo valores devidos, inclusive a título da multa pela rescisão antecipada, fica
                desde já autorizada a cobrança pela<strong> Glambox </strong>referente aos valores
                eventualmente devidos por intermédio dos meios legais disponíveis, inclusive sua
                inclusão junto aos cadastro de maus pagadores dos órgãos de proteção ao crédito e
                Birôs de Crédito – tais como Serasa e SPC -, e demais medidas cabíveis para
                satisfação do crédito.
              </p>
              <p>
                A possibilidade de que um pagamento possa ser realizado via boleto bancário,
                seguindo o procedimento estabelecido neste Termo, não significa qualquer alteração
                do método de pagamento informado no momento do Seu cadastro e Adesão a este Termo,
                tratando-se de mera liberalidade por parte da<strong> Glambox</strong>, que no mês
                seguinte providenciará a cobrança novamente no cartão de crédito, tal qual informado
                neste Termo.
              </p>
              <p>
                O envio dos kits somente ocorrerá após a confirmação do pagamento dos valores, caso
                a cobrança não tenha ocorrido de uma única vez de forma parcelada. Neste caso,
                eventual atraso na entrega, em descumprimento aos prazos estabelecidos neste Termo,
                não será de responsabilidade da<strong> Glambox</strong>.
              </p>
              <p>
                A periodicidade das cobranças que forem cobradas de uma única vez, de forma
                parcelada, dependerá do plano de Assinatura escolhido e da periodicidade das
                renovações. Em alguns casos, a data de pagamento poderá ser alterada, por exemplo,
                se a Forma de Pagamento não puder ser cobrada ou se a sua assinatura paga começar em
                um dia que não existe em um determinado mês.
              </p>
              <p>
                De tempos em tempos, poderemos alterar nossos planos de Assinatura e os preços de
                nossos serviços. Os valores da Assinatura poderão ser revisados periodicamente para
                melhor adequação ao contínuo aprimoramento de nossos serviços. Nós também poderemos
                ajustar o valor de sua assinatura anualmente, ou com maior frequência, conforme
                permitido pela legislação vigente, de acordo com a inflação estabelecida no período
                e índices oficiais aplicáveis. Quaisquer alterações de preço ou alterações em Seus
                planos de Assinatura serão aplicadas somente 30 (trinta) dias após o envio da
                notificação a você. Caso Você não concorde com a alteração dos valores, Você poderá
                cancelar a Assinatura, sem qualquer ônus, em até 07 (sete) dias do recebimento das
                informações sobre os custos adicionais. Findo o prazo sem que haja o cancelamento
                dos serviços, sem que o cancelamento tenha ocorrido, o novo valor será considerado
                aceito e passará a ser cobrado nas faturas seguintes.
              </p>
            </li>
            <li className="mt-3">
              <h6>Vigência, Renovação e Extinção / Política de Cancelamento</h6>
              <p>
                Conforme os Planos de Assinatura, este Termo de Aceite é celebrado pelo prazo de:
                (i) 01 (um) mês; (ii) 06 (seis) meses; ou, (iii) 12 (doze) meses; conforme opção que
                Você escolheu na data de Adesão, renovação ou por solicitação Sua para alteração e
                disponíveis no Website, tendo recebido as condições comerciais vantajosas oferecidas
                pela
                <strong> Glambox </strong>e mencionadas neste Termo de Aceite e demais comunicações
                com a<strong> Glambox</strong>, conforme o prazo de permanência escolhido
                (“Descontos”),{' '}
                <strong>
                  <u>
                    razão pela qual Você se compromete a permanecer como assinante da Glambox, pelo
                    prazo mínimo do Seu Plano de Assinatura (“Prazo de Permanência”), contados da
                    data de início da sua Assinatura e da Adesão a este Termo.
                  </u>
                </strong>
              </p>
              <p>
                <strong>
                  <u>
                    PARA TODOS OS EFEITOS, O VALOR DA SUA ASSINATURA SERÁ CALCULADO SOBRE O VALOR DO
                    PLANO DE ASSINATURA DE 01 (UM) MÊS. CONFORME VOCÊ OPTE POR ESCOLHER O PLANO DE
                    06 (SEIS) MESES OU 01 (UM) ANO, A GLAMBOX LHE CONCEDERÁ DESCONTOS SOBRE O VALOR
                    DO PLANO DE ASSINATURA, QUE SERÃO PREVIAMENTE INFORMADOS À VOCÊ, QUE CONSISTEM
                    NO VALOR INTEGRAL DOS PLANOS SEMESTRAL E/OU ANUAL (SEM A UTILIZAÇÃO DE CUPOM(NS)
                    DE DESCONTO), E QUE SERÃO INFERIORES AO VALOR DO PLANO MENSAL (SE CONSIDERADO O
                    MESMO PERÍODO DE TEMPO).
                  </u>
                </strong>
              </p>
              <p>
                Você poderá cancelar a Assinatura no prazo de 07 (sete) dias a contar da data de
                adesão ou da data do recebimento do{' '}
                <strong>
                  <u>primeiro</u>
                </strong>{' '}
                Kit, por meio dos canais de comunicação disponibilizados – constantes neste Termo.
                Na hipótese de ter sido realizada a entrega do primeiro Kit, a
                <strong> Glambox </strong>
                gerará um código de devolução ou providenciará a coleta do Kit para que retorne até
                sua sede para conferência quanto aos Brindes, Amostras, produtos e itens constantes
                no Kit. A devolução de quaisquer valores somente ocorrerá após a conferência pela
                <strong> Glambox</strong>.
              </p>
              <p>
                Após isso, no caso do cancelamento ter se operado dentro dos 07 (sete) dias a contar
                da data de adesão ou da data do recebimento do{' '}
                <strong>
                  <u>primeiro</u>
                </strong>{' '}
                Kit, a<strong> Glambox </strong>
                providenciará o estorno, reembolso ou, de alguma forma, a restituição dos valores
                que Você pagou. Você declara ter ciência de que a efetivação do estorno em cartão de
                crédito depende de fatores externos a<strong> Glambox</strong>, tais como data de
                fechamento de sua fatura, regras instituídas pela bandeira do Seu cartão, e
                critérios do emissor, e quaisquer reivindicações quanto a data de efetivação do
                estorno devem ser realizadas diretamente no instituidor do arranjo de pagamento,
                considerando-se para tanto a bandeira de Seu cartão ou o emissor dele.
              </p>
              <p>
                <strong>
                  <u>
                    Caso Você tenha realizado a Assinatura optando por seguir com um Plano de
                    Assinatura pelo prazo de 06 (seis) meses ou 01 (um) ano, e solicite o
                    cancelamento fora das hipóteses aqui permitidas, a Glambox poderá cobrar uma
                    multa em decorrência da rescisão antecipada. A rescisão, fora das hipóteses
                    permitidas por lei, é uma violação a este Contrato. Neste caso, para o cálculo
                    da multa pela rescisão, a Glambox se reserva o direito de retirará os descontos
                    concedidos, calculando sobre o valor da do Plano da Assinatura Mensal, e
                    proporcional a quantidade de meses faltantes para o encerramento do Plano de
                    Assinatura.
                  </u>
                </strong>
              </p>
              <p>
                <strong>
                  Independentemente do plano de Assinatura que Você escolher: (i) 01 (um) mês; (ii)
                  06 (seis) meses; ou, (iii) 12 (doze) meses; ao final do período de vigência da
                  Assinatura, o presente Termo será renovado automaticamente, por igual período ao
                  do Plano de Assinatura escolhido e vigente anteriormente. Neste caso, a Glambox
                  enviará um e-mail informando quanto ao encerramento do plano de Assinatura e a sua
                  renovação automática, possibilitando ainda que Você realize o cancelamento da
                  Assinatura e rescisão deste Termo, antes da renovação. Caso Você não manifeste o
                  desejo de encerrar a Assinatura, esta será renovada por igual período ao da
                  Assinatura anterior,{' '}
                </strong>{' '}
                momento em que a<strong> Glambox </strong>passará a programar o seu negócio contando
                com o cumprimento do contrato pelo período da renovação.
              </p>
              <p>
                Você também poderá, no ato de Adesão ou a qualquer momento antes da renovação,
                desabilitar a renovação automática por intermédio do Seu cadastro como assinante ou
                dos canais de comunicação disponibilizados pela<strong> Glambox</strong>.
              </p>
              <p>
                Em razão dos prazos estabelecidos, bem como a necessidade de adequá-los ao prazo
                para entrega do Kit, a política de cancelamento para cada prazo contratual será:
              </p>
              <p> </p>
              <p>
                <strong>(i)</strong> Tendo sido celebrado pelo prazo de 01 (um) mês: Considerando os
                prazos para entrega do primeiro Kit, bem como a
                <strong>
                  <u> renovação automática </u>
                </strong>
                de sua Assinatura, ao final do período de vigência do Plano de Assinatura escolhido
                por Você, a<strong> Glambox </strong>realizará a renovação automática do Seu
                contrato mensal todo o dia 01º (primeiro) de cada mês, a fim de que ela possa
                programar o seu negócio contando com o cumprimento do contrato pelo período da
                renovação. Assim Você poderá solicitar o cancelamento da renovação automática em até
                05 (cinco) dias antes da data de renovação da Assinatura, ou no caso da primeira
                renovação, em até 07 (sete) dias após o recebimento do Kit. Esta possibilidade de
                cancelamento após 07 (sete) dias do recebimento se aplica apenas para a primeira
                renovação, considerando que nas demais renovações Você já será de conhecimento do
                sistema. Além disso, parte dos Serviços prestados pela
                <strong> Glambox </strong>envolvem a surpresa do recebimento do Kit, razão pela
                qual, nos termos da cláusula de limitação de responsabilidade, Você não poderá
                alegar descontentamento com alguns itens. Porém, Você poderá desabilitar a renovação
                dos meses seguintes, sem qualquer ônus. Caso o cancelamento seja feito dentro do
                prazo estabelecido para a entrega do<strong> primeiro </strong>Kit entregue após a
                renovação, a<strong> Glambox </strong>gerará um código de devolução ou providenciará
                a coleta do Kit para que retorne até sua sede para conferência quanto aos Brindes,
                Amostras, produtos e itens constantes no Kit. A devolução de quaisquer valores
                somente ocorrerá após a conferência pela<strong> Glambox</strong>.
              </p>
              <p>
                Você tem ciência de que, dependendo da data de suas Assinatura e Adesão a este
                Termo, poderá ocorrer situações em que sua Assinatura mensal seja renovada antes da
                entrega do Kit. Neste caso, a<strong> Glambox </strong>envidará todos os esforços
                para que sua entrega ocorra o mais rápido possível, a fim de que sua experiência
                seja satisfatória.
              </p>
              <p>
                Importante informar que na hipótese de ocorrer a primeira renovação do sua
                Assinatura mensal sem que Você tenha recebido o primeiro Kit, permanece a
                possibilidade de exercício do Seu direito ao arrependimento dentro dos 07 (sete)
                dias após o recebimento do
                <strong> primeiro </strong>Kit entregue após a renovação, subsistindo as regras de
                cancelamento.
              </p>
              <p>
                <strong>(ii)</strong> Na hipótese de Você não realizar o cancelamento em até 05
                (cinco) dias antes da data da renovação Assinatura do mês subsequente ao mês de
                adesão, o prazo de vigência será prorrogado por períodos iguais, por meio de
                modalidade de renovação automática, sendo devido o pagamento do valor da Assinatura;
              </p>
              <p>
                <strong>(iii)</strong> Tendo sido celebrado pelo prazo de 06 (seis) meses ou 12
                (doze) meses: ao final do período de vigência de sua Assinatura a
                <strong> Glambox </strong>poderá realizar a renovação automática, a fim de que ela
                possa programar o seu negócio contando com o cumprimento do contrato pelo período da
                renovação. Assim Você poderá solicitar o cancelamento da
                <strong> renovação automática </strong>em até 05 (cinco) dias antes da data de
                renovação da Assinatura, ou no caso da primeira renovação, em até 07 (sete) dias
                após o recebimento do Kit. Esta possibilidade de cancelamento após 07 (sete) dias do
                recebimento se aplica apenas para a primeira renovação, considerando que nas demais
                renovações Você já será de conhecimento do sistema. Além disso, parte dos Serviços
                prestados pela
                <strong> Glambox </strong>envolvem a surpresa do recebimento do Kit, razão pela
                qual, nos termos da cláusula de limitação de responsabilidade, Você não poderá
                alegar descontentamento com alguns itens. Porém, Voce poderá desabilitar a renovação
                dos períodos posteriores, sem qualquer ônus. Caso o cancelamento seja feito dentro
                do prazo estabelecido para a entrega do<strong> primeiro </strong>Kit entregue após
                a renovação, a<strong> Glambox </strong>gerará um código de devolução ou
                providenciará a coleta do Kit para que retorne até sua sede para conferência quanto
                aos Brindes, Amostras, produtos e itens constantes no Kit. A devolução de quaisquer
                valores somente ocorrerá após a conferência pela<strong> Glambox</strong>. Para que
                o estorno seja efetuado, o Kit deverá ser devolvido em perfeitas condições, de forma
                que o valor correspondente à devolução do Kit será de responsabilidade da
                <strong> Glambox</strong>.
              </p>
              <p>
                <strong>
                  <u>
                    Caso Você tenha realizado a Assinatura optando por seguir com um Plano de
                    Assinatura pelo prazo de 06 (seis) meses ou 01 (um) ano, e solicite o
                    cancelamento fora das hipóteses aqui permitidas, a Glambox poderá cobrar uma
                    multa em decorrência da rescisão antecipada. A rescisão, fora das hipóteses
                    permitidas por lei, é uma violação a este Contrato. Neste caso, para o cálculo
                    da multa pela rescisão, a Glambox se reserva o direito de retirará os descontos
                    concedidos (inclusive eventuais códigos e/ou cupons de desconto) calculando
                    sobre o valor da do Plano da Assinatura, que é o valor do Plano de Assinatura
                    Mensal, e proporcional a quantidade de meses faltantes para o encerramento do
                    Plano de Assinatura.
                  </u>
                </strong>
              </p>
              <p>
                Por tratar-se de um serviço de assinatura, a Assinatura poderá ser cancelada, a
                qualquer tempo, mediante a cobrança de multa contratual dos seguintes percentuais
                dos valores dos Plano de Assinatura:
              </p>
              <p>
                <strong>(i)</strong> Se adquirido a assinatura de 1 (um) mês: a multa contratual
                será de 14,30% do valor da Assinatura, se já efetuada a cobrança no cartão de
                crédito o valor poderá ser descontado de eventual saldo a ser estornado. Caso não
                haja valores à serem estornados, a<strong> Glambox </strong>poderá realizar a
                cobrança do saldo em cartão de crédito. Na hipótese de não haver saldo em cartão de
                crédito, a<strong> Glambox </strong>
                poderá realizar duas tentativas de cobrança em cartão de crédito, e, caso não
                obtenha êxito, enviar-lhe-á uma cobrança via boleto bancário, o qual será enviado
                para os Seus contatos eletrônicos constantes no Seu cadastro e informado por você no
                momento da Adesão e vinculados a sua Assinatura (inclusive e-mail; SMS, entre outros
                que a<strong> Glambox </strong>entender serem necessários). para pagamento em até 03
                (três) dias úteis.
                <strong>
                  {' '}
                  A Glambox<u> não </u>enviará o boleto em formato físico para o Seu endereço.{' '}
                </strong>
                Na eventualidade de não haver o pagamento do boleto bancário dentro do prazo
                estabelecido inclusive sua inclusão junto aos cadastro de maus pagadores dos órgãos
                de proteção ao crédito e Birôs de Crédito – tais como Serasa e SPC - e demais
                medidas cabíveis para satisfação do crédito.
              </p>
              <p>
                <strong>(ii)</strong> Se adquirido a assinatura de 6 (seis) meses: a multa
                contratual será: o valor do desconto recebido em relação ao Plano de Assinatura
                Mensal multiplicado pelo número de meses restantes para o término do Plano de
                Assinatura, se já efetuada a cobrança no cartão de crédito o valor poderá ser
                descontado de eventual saldo a ser estornado. Caso não haja valores à serem
                estornados, a<strong> Glambox </strong>poderá realizar a cobrança do saldo em cartão
                de crédito. Na hipótese de não haver saldo em cartão de crédito, a
                <strong> Glambox </strong>poderá realizar duas tentativas de cobrança em cartão de
                crédito, e, caso não obtenha êxito, enviar-lhe-á uma cobrança via boleto bancário, o
                qual será enviado para os Seus contatos eletrônicos constantes no Seu cadastro e
                informado por você no momento da Adesão e vinculados a sua Assinatura (inclusive
                e-mail; SMS, entre outros que a<strong> Glambox </strong>entender serem
                necessários). para pagamento em até 03 (três) dias úteis.{' '}
                <strong>
                  {' '}
                  A Glambox<u> não </u>enviará o boleto em formato físico para o Seu endereço.{' '}
                </strong>{' '}
                Na eventualidade de não haver o pagamento do boleto bancário dentro do prazo
                estabelecido inclusive sua inclusão junto aos cadastros de maus pagadores dos órgãos
                de proteção ao crédito e Birôs de Crédito – tais como Serasa e SPC - e demais
                medidas cabíveis para satisfação do crédito.
              </p>
              <p>
                <strong>
                  (iii) Se adquirido a assinatura de 12 (doze) meses: a multa contratual será: o
                  valor do desconto recebido em relação ao Plano de Assinatura Mensal multiplicado
                  pelo número de meses restantes para o término do Plano de Assinatura, se já
                  efetuada a cobrança no cartão de crédito o valor poderá ser descontado de eventual
                  saldo a ser estornado. Caso não haja valores à serem estornados, a
                  <strong> Glambox </strong>poderá realizar a cobrança do saldo em cartão de
                  crédito. Na hipótese de não haver saldo em cartão de crédito, a
                  <strong> Glambox </strong>poderá realizar duas tentativas de cobrança em cartão de
                  crédito, e, caso não obtenha êxito, enviar-lhe-á uma cobrança via boleto bancário,
                  o qual será enviado para os Seus contatos eletrônicos constantes no Seu cadastro e
                  informado por você no momento da Adesão e vinculados a sua Assinatura (inclusive
                  e-mail; SMS, entre outros que a<strong> Glambox </strong>entender serem
                  necessários). para pagamento em até 03 (três) dias úteis.{' '}
                  <strong>
                    {' '}
                    A Glambox<u> não </u>enviará o boleto em formato físico para o Seu endereço.{' '}
                  </strong>{' '}
                  Na eventualidade de não haver o pagamento do boleto bancário dentro do prazo
                  estabelecido inclusive sua inclusão junto aos cadastros de maus pagadores dos
                  órgãos de proteção ao crédito e Birôs de Crédito – tais como Serasa e SPC - e
                  demais medidas cabíveis para satisfação do crédito.
                </strong>
              </p>
              <p>
                Como exemplo, na hipótese de Você ter optado pela Assinatura Anual (12 meses) pelo
                valor hipotético de R$ 814,80 (oitocentos e quatorze reais e oitenta centavos)
                parcelado em 12 vezes de R$ 67,90 (sessenta e sete reais e noventa centavos) e
                cancele ela depois do 3º (terceiro) mês e antes de completado o 4º (quarto) mês após
                a adesão, o valor da multa contratual será de: R$ 82,90 (que é o valor hipotético da
                Assinatura e do Plano mensal, sem qualquer desconto) – (subtraindo-se) R$ 67,90 (que
                é o valor hipotético do Plano anual) = 15,00 (quinze reais) x (multiplicando-se)
                pelo número de meses restantes para o término do Plano de Assinatura (no exemplo
                seria 09), então temos a seguinte equação:
              </p>
              <p>
                R$ 82,90 – R$ 67,90 = R$ 15,00
                <br /> R$ 15,00 X 09 = 135,00
                <br /> Estes R$ 135,00 (cento e trinta e cinco reais), na hipótese do caso acima,
                seria o saldo da multa.
              </p>
              <p>
                O valor de Assinatura acima citado deve ser encarado apenas como um exemplo para
                melhor ilustração do cálculo de multa contratual, devendo ser substituído pelo valor
                da Assinatura pago no momento da Assinatura e Adesão a este Termo.
              </p>
              <p>
                Uma vez feito o cancelamento, Você receberá o(s) Kit(s) correspondente(s) ao último
                pagamento da Assinatura realizado, exceto na hipótese (i) acima, caso Você prefira o
                estorno à entrega do Kit.
              </p>
              <p>
                Na hipótese (i) acima, caso Você prefira a entrega do Kit ao estorno, a solicitação
                de cancelamento e a preferência pela entrega do Kit ao estorno deverá ser comunicada
                à<strong> Glambox </strong>até o último dia do mês. Após esse prazo, o Kit será
                entregue e o estorno não será realizado.
              </p>
              <p>
                Ao solicitar o cancelamento de Sua Assinatura, Você terá Seus Glampoints congelados
                por 30 (trinta) dias. Passado esse prazo, caso Você não renove ou reative sua
                Assinatura, os Glampoints serão expirados.
              </p>
              <p>
                Em caso de renovação ou reativação de Assinatura dentro do prazo acima citado, Você
                poderá utilizar os Glampoints congelados.
              </p>
              <p>
                O cancelamento da Assinatura não ilide a responsabilidade das Partes de liquidarem
                as contraprestações que estiverem pendentes ao tempo do cancelamento, que permanecem
                exigíveis.
              </p>
              <p>
                Nós também poderemos cancelar a sua Assinatura se Você (i) infringir as regras deste
                Termo ou da Política de Privacidade; (ii) se Você fizer um uso não autorizado do
                Kit, Cupons Promocionais e Códigos de Desconto, demonstrar conduta incompatível com
                a finalidade da Assinatura, a moral e bons costumes e/ou alterar a finalidade dos
                Brindes, Amostras, produtos itens e conteúdos dos Kits; ou, (iii) violar leis e
                regulamentos.
              </p>
            </li>
            <li className="mt-3">
              <h6>Capacidade para Aceitar os Termos e Condições</h6>
              <p>
                Você deve ter 18 (dezoito) anos ou ser capaz civilmente, ou estar de posse de
                autorização legal dos pais ou de tutores, e plenamente capaz de consentir com os
                termos, condições, obrigações, afirmações, representações e garantias descritas
                neste Termo de Aceite e documentos incorporados.
              </p>
              <p>
                Se você tem menos de 18 (dezoito) anos, ou é menor de idade ou incapaz civilmente
                segundo a regra de sua localidade, você poderá utilizar o Serviço apenas mediante a
                participação de pai, mãe ou responsável.
              </p>
            </li>
            <li className="mt-3">
              <h6>Obrigações e responsabilidades da Glambox</h6>
              <p>
                São obrigações da<strong> Glambox</strong>:
              </p>
              <p>
                <strong>(i)</strong> prestar os Serviços em estrita observância a este Termo de
                Aceite e em conformidade com a legislação aplicável;
              </p>
              <p>
                <strong>(ii)</strong> prestar informações claras, completas e precisas sobre os
                Serviços disponibilizados;
              </p>
              <p>
                <strong>(iii)</strong> envidar os melhores esforços para garantir a acessibilidade e
                funcionalidade do Website;
              </p>
              <p>
                <strong>(iv)</strong> preservar a confidencialidade dos dados pessoais fornecidos
                por Você, em conformidade com a Política de Privacidade disponível no Website; e
              </p>
              <p>
                <strong>(v)</strong> disponibilizar canais de atendimento, comprometendo-se a seguir
                a legislação aplicável e as condições estabelecidas neste Termo.
              </p>
              <p>
                Você se declara ciente de que não terá oportunidade de selecionar as indicações,
                marcas, modelos, quantidades, tipos nem quaisquer outras características dos
                Brindes, Amostras, produtos, Materiais Promocionais e Cupons ou Códigos de Desconto
                que compõe os Kits, que serão entregues em caráter de “surpresa”, sendo possível
                que, eventualmente, determinado Brinde não seja compatível com o Seu perfil
                informado no momento do Seu cadastro e Adesão a este Termo, no que diz respeito, por
                exemplo, ao gênero (masculino ou feminino), preferências pessoais, cor e tipo de
                cabelo, cor de pele, etc.
              </p>
              <p>
                É vedado a Você comercializar os Brindes, Amostras e Cupons ou Códigos de Desconto
                recebidos, o que poderá ensejar a suspensão e/ou rescisão imediata do presente Termo
                de Aceite, a critério exclusivo da<strong> Glambox</strong>.
              </p>
              <p>
                Os serviços prestados pela<strong> Glambox </strong>são fornecidos “no estado em que
                se encontram”, sem garantias ou condições. Especificamente, os Nossos serviços podem
                não estar livres de interrupções ou erros. Você renuncia a todas e quaisquer
                indenizações por danos indiretos, morais e materiais contra a
                <strong> Glambox</strong>. A<strong> Glambox </strong>não é responsável pela
                expectativa gerada por Você com os Serviços, incorreções por Você informadas,
                serviços, Brindes, Amostras ou produtos de terceiros. Este Termo não limitará
                nenhuma garantia ou direitos não renunciáveis de proteção ao consumidor, aos quais
                você possa ter direito de acordo com a legislação aplicável.
              </p>
              <p>
                Alguns dos serviços ou itens dos Kits provêm de terceiros. Terceiros estes
                responsáveis por fornecer serviços ou os itens, não sendo a
                <strong> Glambox </strong>responsável pelos itens de terceiros, mesmo que constantes
                em Seus Kits.
              </p>
              <p>
                A<strong> Glambox </strong>não será responsável ainda por:
              </p>
              <p>
                <strong>(i)</strong> defeitos de projeto, fabricação ou de informação dos Brindes,
                ou pelos prejuízos deles decorrentes, cuja responsabilidade é exclusiva de seus
                respectivos fabricantes, importadores e fornecedores, devidamente identificados nos
                Brindes, Amostras, produtos, itens, Códigos ou Cupons promocionais;
              </p>
              <p>
                <strong>(ii)</strong> por qualquer aspecto dos produtos, serviços ou ofertas
                anunciadas nos Materiais Promocionais, cuja responsabilidade é exclusiva de seus
                respectivos anunciantes;
              </p>
              <p>
                <strong>(iii)</strong> pelas promoções anunciadas nos Códigos ou Cupons de Desconto,
                cuja responsabilidade é de seus respectivos emissores;
              </p>
              <p>
                <strong>(iv)</strong> pela não entrega dos Kits em razão do fornecimento de dados
                inverídicos ou desatualizados;
              </p>
              <p>
                <strong>(v)</strong> por quaisquer prejuízos advindos em razão de extravio ou uso
                indevido de sua senha pessoal de acesso ao Website, se decorrentes de conduta
                culposa atribuível a Você, até que a<strong> Glambox </strong>seja formalmente
                informada a respeito;
              </p>
              <p>
                <strong>(vi)</strong> por eventuais interrupções de acessibilidade ao Website sobre
                as quais não tem controle, tais como em decorrência de falta de energia elétrica,
                interrupção da conectividade via internet pelo provedor, problemas de hardware ou
                software no equipamento de acesso utilizado por Você, etc.; e,
              </p>
              <p>
                <strong>(vii)</strong> por quaisquer danos ou prejuízos decorrentes de força maior
                ou caso fortuito.
              </p>
            </li>
            <li className="mt-3">
              <h6>Das Suas obrigações:</h6>
              <p>
                São Suas obrigações, além das constantes na legislação aplicável ou previstas neste
                Termo:
              </p>
              <p>
                <strong>(i)</strong> utilizar os Brindes, Amostras, produtos, itens enviados pela
                <strong> Glambox </strong>de forma compatível com o uso a que se destinam e em
                conformidade com as instruções fornecidas pelos seus respectivos fabricantes;
              </p>
              <p>
                <strong>(ii)</strong> fornecer informações verdadeiras, completas e precisas no
                momento da adesão e mantê-las atualizadas por todo o período contratual, informando
                à<strong> Glambox </strong>a eventual mudança os dados para cobrança e do endereço
                de entrega dos Kits até o quinto dia do mês, sob pena da entrega do Kit ser adiada
                para o mês seguinte ao da atualização cadastral;
              </p>
              <p>
                <strong>(iii)</strong> comunicar à<strong> Glambox</strong>, pelos canais de
                atendimento disponibilizados e indicados neste Termo de Aceite ou no Website, o
                extravio ou uso indevido de sua senha pessoal de acesso ao Website imediatamente
                após o conhecimento do fato; e,
              </p>
              <p>
                <strong>(iv)</strong> arcar com as despesas necessárias para Seu acesso, via
                internet, do conteúdo digital oferecido pela<strong> Glambox</strong>;
              </p>
              <p>
                <strong>(v)</strong> realizar a Assinatura exclusivamente por meio do Website, de
                acordo com as condições estabelecidas pela<strong> Glambox</strong>, tendo ciência e
                concordando com os prazos de entrega, eventuais valores de frete, e com os meios de
                pagamento disponibilizados pela<strong> Glambox</strong>;
              </p>
              <p>
                <strong>
                  (vi) VOCÊ DECLARA TER CIÊNCIA DE QUE A ASSINATURA SE DESTINA A EXPERIÊNCIA COM OS
                  SERVIÇOS E/OU PRODUTOS FORNECIDOS PELA GLAMBOX, SENDO VEDADA A COMERCIALIZAÇÃO DOS
                  KITS RECEBIDOS E/OU DOS PRODUTOS, BRINDES, AMOSTRAS QUE O(S) COMPÕE(M).
                </strong>
              </p>
            </li>
            <li className="mt-3">
              <h6>Atendimento ao Assinante</h6>
              <p>
                Você poderá contatar a<strong> Glambox </strong>a qualquer momento para tirar suas
                dúvidas, realizar solicitações ou reclamações, por intermédio do Serviço de
                Atendimento ao Consumidor (SAC) da<strong> Glambox</strong>, cujo horário de
                funcionamento se dará em dias úteis, das 09h00 às 18h00, pelo seguintes canais:
              </p>
              <p>
                <strong>(i)</strong> Central de Ajuda (localizada na página inicial do site, no
                canto inferior direito).
              </p>
              <p>
                <i>
                  Caso prefira entrar em contato por correspondência regular, envie sua solicitação
                  ao endereço:<strong> Sac B4A</strong>, localizada na Rua Pequetita, nº.: 111, 7º
                  andar, Vila Olímpia - CEP 04.552-060 - Cidade de São Paulo, Estado de São Paulo.
                </i>
              </p>
              <p>
                Enviaremos informações relacionadas à sua conta (por exemplo, autorizações de
                pagamento, cobranças, alterações de senha ou Forma de Pagamento, mensagens de
                confirmação, notificações), somente em formato eletrônico como, por exemplo, por
                meio de e-mails para o endereço fornecido durante a inscrição.
              </p>
            </li>
            <li className="mt-3">
              <h6>Disposições Finais</h6>
              <p>
                Legislação aplicável. Estes Termos de uso devem ser regidos por e interpretados de
                acordo com a legislação do Brasil.
              </p>
              <p>
                Subsistência e Independência: Se qualquer disposição ou disposições destes Termos de
                uso forem consideradas inválidas, ilegais ou não aplicáveis, a validade, legalidade
                e aplicabilidade das demais disposições devem permanecer em pleno vigor.
              </p>
              <p>
                Declaração: Toda informação fornecida por Você, por meio das Páginas, cadastros,
                Assinaturas e meios de contato, deverá ser verdadeira. Assim, o Você garante a
                <strong> Glambox </strong>encoraja que, caso verifique a incorreção, incompletude ou
                inexatidão de algum dado, exerça o Seu direito de correção e atualização dos dados
                incompletos, inexatos ou desatualizados, para manter toda a informação fornecida a
                <strong> Glambox </strong>de forma que sempre reflita a realidade de Seus dados.
              </p>
              <p>
                Banco de Dados. Você concorda que a<strong> Glambox </strong>colete informações para
                realização de acompanhamento de tráfego, com intuito de identificar grupos de perfil
                de usuários e para fins de orientação publicitária. Você concorda, ainda, que a
                <strong> Glambox </strong>lhe envie mensagens de e-mail ou outras correspondências
                de caráter informativo, referentes a comunicações específicas inerentes aos
                Serviços, bem como mensagens de natureza comercial e promocional. Para maiores
                informações, favor consultar o documento “Política de Privacidade”, acessível por
                meio do link:
                <a href="https://www.glambox.com.br/politica-de-privacidade/">
                  https://www.glambox.com.br/politica-de-privacidade/
                </a>
                . Tal documento constitui parte integrante e indissociável do presente Termo e
                deverá ser lido atentamente por você.
              </p>
              <p>
                Sucessão. Este Termo de Aceite vincula as Partes e seus sucessores, sejam eles a
                qualquer título.
              </p>
              <p>
                Cessão. Este Termo de Aceite e quaisquer autorizações aqui previstas não podem ser
                transferidos ou cedidos por Você, mas podem ser transferidos pela
                <strong> Glambox </strong>sem qualquer restrição ou notificação prévia.
              </p>
              <p>
                Responsabilidade. Cada Parte será responsável individualmente pelos atos que
                praticar, não sendo admitida solidariedade ou subsidiariedade presumidas.
              </p>
              <p>
                Renúncia. A renúncia a qualquer termo deste Termo de Aceite não será considerada
                renúncia adicional ou contínua a esse ou a qualquer outro termo, e a omissão por
                parte da
                <strong> Glambox </strong>de não executar qualquer direito ou cláusula de acordo com
                este Termo de Aceite não constituirá renúncia ou novação a tal direito ou cláusula.
              </p>
              <p>
                Foro. As Partes elegem o foro da cidade de São Paulo – SP, para dirimir quaisquer
                dúvidas ou litígios relacionados a este Termo de Aceite, renunciando a qualquer
                outro por mais privilegiado que seja.
              </p>
            </li>
          </ol>
        </div>
      </div>
    );
  };

  render() {
    return <div className={'p-2 p-lg-5'}>{this.renderTermosGG()}</div>;
  }
}
